import { getByPath } from '@/utils'
const ApplyVat = (value, vat) => value * ((100 + vat) / 100)
const RemoveVat = (value, vat) => value / ((100 + vat) / 100)
const CeilToNearest = (value, nearest) => Math.ceil(value / nearest) * nearest

function Round(value, rounding) {
  if (rounding === 'none') return value
  return CeilToNearest(value, parseInt(rounding))
}

function getMargin(pricing) {
  switch (pricing.margin.type) {
    case 'fixed':
      return pricing.margin.value || 0
    case 'percent':
      return (pricing.value * pricing.margin.value) / 100
  }
}

const NetMethods = {
  add(pricing, options = {}) {
    let { area = 1, round = true } = options

    let sum = pricing.value + getMargin(pricing)
    if (pricing.type === 'area') sum *= area

    let net = sum
    let gross = ApplyVat(net, pricing.vat)

    if (round) return RemoveVat(Round(gross, pricing.rounding), pricing.vat)

    return net
  },
  diff(pricing, options = {}) {
    const { defaultProduct, product, area = 1, round = true } = options

    let sum = pricing.value + getMargin(pricing)
    if (pricing.type === 'area') sum *= area

    let net = sum
    let gross = ApplyVat(net, pricing.vat)

    let result = round ? RemoveVat(Round(gross, pricing.rounding), pricing.vat) : net

    if (!defaultProduct || defaultProduct.product.id === product.id) return result

    return (
      result -
      getNet(getByPath('overrides.pricing', defaultProduct) || getByPath('product.pricing', defaultProduct), {
        ...options,
        product: defaultProduct.product,
      })
    )
  },
}

function getNet(pricing, options = {}) {
  const { pricingMethod = 'add' } = options

  if (pricing.type === 'request') return
  return NetMethods[pricingMethod](pricing, options)
}

function getGross(pricing, options = {}) {
  if (pricing.type === 'request') return

  const { round = true, pricingMethod = 'add' } = options

  let net = NetMethods[pricingMethod](pricing, {
    ...options,
    round: false,
  })
  let gross = ApplyVat(net, pricing.vat)

  if (round) return Round(gross, pricing.rounding)

  return gross
}

export { getNet, getGross }
